import { render } from "./media-carousel.vue?vue&type=template&id=82c08814"
import script from "./media-carousel.vue?vue&type=script&lang=js"
export * from "./media-carousel.vue?vue&type=script&lang=js"

import "./media-carousel.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__